import $ from 'jquery/src/jquery'
import 'select2'                       // globally assign select2 fn to $ element
import 'select2/dist/css/select2.css'  // optional if you have css loader

export default () => {
    const nodeSelectors = {
        container: '[js-form="container"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        $(window).on('load', function () {
            initSelect()
        })
    }

    function initSelect() {
        //Add holder around the select2
        let $customSelects = $('select')
        $customSelects.each(function () {
            let holderID
            let selectClassList = $(this).data("class")

            if ( $(this).attr("id") ) {
                holderID = $(this).attr("id")
            } else {
                holderID = $(this).attr("name")
            }

            holderID = holderID.concat("-holder")

            $(this).wrap('<div style="position: relative" class="select-2-holder" id="' + holderID + '"></div>')

            let selectHolder = $( "#" + holderID )

            $(selectHolder).find('select').select2({
                dropdownParent: selectHolder,
                dropdownPosition: 'below',
                width: "100%",
                allowClear: false,
                minimumResultsForSearch: -1,
            })

            selectHolder.addClass( selectClassList )
        })
    }

    return Object.freeze({
        init,
    })
}